export default __webpack_public_path__ + "static/media/Group.79a1e10d.png";